import axios from "axios";
import env from "../env";

const api_url = env.API_URL;

export const createNotice = async (body: any, token: string) => {
    try {
        const response = await axios.post(api_url + `notices`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateNotice = async (body: any, token: string) => {
    try {
        const response = await axios.put(api_url + `notices`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getNotices = async (token: string) => {
    try {
        const response = await axios.get(api_url + `notices`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const deleteNotice = async (noticeId: string, userId: string, userType: string, token: string) => {
    try {
        const response = await axios.delete(api_url + `notices/${noticeId}?userId=${userId}&userType=${userType}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getNoticeById = async (noticeId: string, token: string) => {
    try {
        const response = await axios.get(api_url + `notices/${noticeId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
